import * as EDIT_TYPE from '@/constants/okr-edit-type'
import * as APPROVAL_STATUS from '@/constants/approval-status'
import * as LOCK_STATUS from '@/constants/lock-status'

export default {
  stateOptions: [
    'Smoothly',
    'Delayed',
    'Risky',
    'Abandoned'
  ],
  nothing: 'none',
  list: {
    createObjective: 'Create Objective',
    createKeyResult: 'Set the path to achivement',
    delete: 'Delete',
    alignOthers: 'Align To Others',
    inviteToAlign: 'Invite to Align',
    notAligned: 'Not Aligned',
    align: 'Align',
    collapseComment: 'Collapse',
    performanceTarget: 'Performance Indicators',
    superior: 'Superior',
    excellent: 'Excellent',
    target: 'Target',
    performanceReview: 'Performance Review',
    performanceIndicators: 'Performance Indicators',
    placeholder: 'Please enter the assessment criteria, if you cannot set the criteria, you can enter "None".',
    superiorPlaceholder: 'Great entrepreneurial spirit to grow the organization and achieve phenomenon milestone for the company',
    excellentPlaceholder: 'Commitment to excellence, sustained outstanding performance and demonstration of dedication to the work',
    targetPlaceholder: 'Please enter the assessment criteria, if you cannot set the criteria, you can enter "None".',
    financialTarget: 'Financial Objective'
  },
  review: {
    title: 'Objective Review',
    inputReview: 'Input review',
    achievement: 'Progress & Achievements',
    achievementPlaceholder: 'Write down the achievement and timeline of the key milestones, then list highlights and lowlights and review them all.',
    problem: 'Decision & Issues ',
    problemPlaceholder: 'Write down all problems and find the specific strategies and plans to resolve them.',
    saveSuccessMessage: 'Review saved successfully',
    uploadButton: 'Upload Attachment',
    uploadMaxSizeWarning: 'The file {filename} exceeds max size({maxFileSize}MB) limit',
    uploadMaxNumWarning: 'Can only upload less than {maxFileNum} files once',
    attachmentLabel: 'Attachments: ',
    placeholder: 'Please input'
  },
  overallReview: {
    title: 'Input review'
  },
  toolbar: {
    followSuccessMessage: 'Follow user successfully',
    unfollowSuccessMessage: 'Unfollow user successfully',
    approvalStatus: {
      [APPROVAL_STATUS.UNCOMMITTED]: '',
      [APPROVAL_STATUS.WAITING_FOR_APPROVAL]: 'Under Review, not available for creating or editing',
      [APPROVAL_STATUS.APPROVED]: '',
      [APPROVAL_STATUS.REJECTED]: 'Rejected, please adjust and resubmit',
      undefined: ''
    },
    lockStatus: {
      [LOCK_STATUS.LOCKED]: 'Currently in the performance review stage, the OKR modification function has been closed.',
      [LOCK_STATUS.UNLOCKED]: '',
      undefined: ''
    },
    publish: {
      publishButton: 'Submit',
      description: 'Confirm to Submit?',
      notifyAssociated: 'Notify to Associated',
      followed: 'Followed',
      alignedToPersons: 'Aligned To',
      beAlignedFromPersons: 'Be Aligned From',
      mentioned: 'Mentioned',
      successMessage: 'Submit successfully. Content will be officially released after the approval.',
      errorMessage: 'Submit failed, please try again',
      weightErrorMessage: 'The total objective percentage must be equal to 100/100, please check again',
      personalDevelopmentErrorMessage: 'Please enter Individual Development, then submit again.',
      organizationalSkillsErrorMessage: 'Please enter Organizational Skills, then submit again.'
    },
    needAlignHint: 'In this page，the objective and key result marked with red dot need to align'
  },
  editDialogTitle: {
    [EDIT_TYPE.CREATE_OBJECTIVE]: 'Create Objective',
    [EDIT_TYPE.EDIT_OBJECTIVE]: 'Edit Objective',
    [EDIT_TYPE.CREATE_KEY_RESULT]: 'Create Key Result',
    [EDIT_TYPE.EDIT_KEY_RESULT]: 'Edit Key Result',
    [EDIT_TYPE.EDIT_PERSONAL_OBJECTIVE]: 'Individual Development',
    [EDIT_TYPE.EDIT_ORGANIZATIONAL_OBJECTIVE]: 'Organizational Skills'
  },
  createObjectiveDialog: {
    successMessage: 'Objective created successfully'
  },
  editObjectiveDialog: {
    contentPlaceholder: 'Please input objective content',
    superiorPlaceholder: 'Great entrepreneurial spirit to grow the organization and achieve phenomenon milestone for the company',
    excellentPlaceholder: 'Commitment to excellence, sustained outstanding performance and demonstration of dedication to the work',
    targetPlaceholder: 'Please enter the assessment criteria, if you cannot set the criteria, you can enter "None".',
    hideOrNot: 'Hide or not',
    successMessage: 'Objective saved successfully',
    hideOrNotTip: 'After hiding, the goals are only visible to the leader, HRBP, HRBP Lead',
    whetherIsAboutFinance: 'Financial Objective or not'
  },
  editKeyResultDialog: {
    contentPlaceholder: 'Please input key result content',
    successMessage: 'Key result saved successfully',
    targetPlaceholder: 'Please input target'
  },
  deleteObjectiveDialog: {
    description: 'Confirm to delete the objective',
    successMessage: 'Objective deleted successfully'
  },
  deleteKeyResultDialog: {
    description: 'Confirm to delete the key result',
    successMessage: 'Key result deleted successfully'
  },
  alignedUser: {
    cancelAlignment: 'Cancel Alignment'
  },
  weightDialog: {
    successMessage: 'The weight of Objective updated successfully'
  },
  progressDialog: {
    progressSuccessMessage: 'The progress of key result updated successfully',
    stateSuccessMessage: 'The state of key result updated successfully'
  },
  autoSaveOnBlur: 'The content will be auto saved on blur',
  notPublishedWarning: {
    title: 'The OKR content of current cycle has not published, Confirm to leave',
    notShowAgain: 'Don\'t show again'
  },
  learnBestCase: 'Learn best OKR case',
  formRules: {
    required: {
      objective: 'Objective content is required',
      keyResult: 'Key result content is require',
      shared: 'The content is require'
    }
  },
  cycle: {
    fullYear: ' Full Year'
  },
  comment: {
    reply: 'Reply',
    send: 'Send',
    sentMessage: 'The Comment sent successfully',
    deletedMessage: 'The Comment deleted successfully',
    commentPlaceholder: 'Comment',
    replyPlaceholder: 'Reply'
  },
  okrListReview: {
    title: 'OKR Review Summary',
    placeholder: 'Please input OKR review summary',
    sentMessage: 'OKR review summary published successfully',
    deletedMessage: 'OKR review summary deleted successfully',
    send: 'Send'
  },
  personalObjective: {
    review: 'review',
    teamBuilding: 'Team Building',
    talentDevelopment: 'Talent Development',
    culturalAtmosphere: 'Cultural Atmosphere',
    professionalPrecipitation: 'Professional Accumulation',
    abilityBreakthrough: 'Ability Breakthrough',
    teamBuildingSelfReview: 'Team Building',
    talentDevelopmentSelfReview: 'Talent Development',
    culturalAtmosphereSelfReview: 'Cultural Atmosphere',
    professionalPrecipitationSelfReview: 'Professional Accumulation',
    abilityBreakthroughSelfReview: 'Ability Breakthrough',
    teamBuildingTip1: 'According to product positioning, classification and key work direction of this function, formulate supporting talent strategy and allocation plan, improve efficacy',
    teamBuildingTip2: 'Please describe regarding the following aspects: [HC and overall talent level], [Key positions in place], and [Team decision-making mechanism and work distribution]:',
    talentDevelopmentTip1: 'Identify key positions based on business priorities and improve job competency',
    talentDevelopmentTip2: 'Please describe in the these aspects: [Core talent training and output(List 1-3 trainees)], [IDP implementation] and [active turnover rate of core talents]:',
    culturalAtmosphereTip1: 'Identify with the company\'s values, formulate and practice team principles, improve team cooperation and morale',
    culturalAtmosphereTip2: 'Please describe regarding the following aspects: [team principles] and [Communication mechanism (goal communication and alignment)]:',
    professionalPrecipitationTip1: 'Through the professional output on projects, accumulate knowledge, methodologies (theories), processes and systems for the team in the area of responsibility.',
    professionalPrecipitationTip2: 'Continuous knowledge accumulation in professional fields, such as case accumulation, project team sharing, workdayUGC accumulation, funview sharing, etc.',
    professionalPrecipitationTip3: 'Areas of Expertise Methods or Methodological Contributions',
    professionalPrecipitationTip4: 'Professional field process and system construction',
    abilityBreakthroughTip1: 'Identify the key points of ability development, and achieve the expected goal of ability improvement (IDP) through task achievement or performance breakthrough in the project.',
    abilityBreakthroughTip2: 'The Correlation of the key points of Capability Advantages and Capability Development with the team objectives(objectives association)',
    abilityBreakthroughTip3: 'The suitability of capacity development with task selection(task matching)',
    abilityBreakthroughTip4: 'Achievement rate of capacity development expectations(result reached)',
    placeholder: 'please input'
  },
  titles: {
    input: 'Enter',
    objectiveTitle: 'Performance Objective',
    leaderTitle: 'Organizational Skills',
    normalTitle: 'Individual Development',
    review: 'Review',
    subTitle: 'Review'

  },
  radio: {
    hide: 'hide',
    not: 'not',
    yes: 'yes',
    no: 'no'
  }
}
